import { z } from "zod";
/**
 * Redaction levels (§7.2). The brain's redaction layer applies these *before*
 * pushing the payload, so third parties (Twilio, ElevenLabs) and the cloud DB
 * only ever see what the level permits. The transform logic lives in the brain;
 * the contract only defines the vocabulary.
 *
 * - open:     full names/titles spoken. "Pitch meeting with Richard at ESG."
 * - initials: "Pitch meeting with R. at E." — recognizable, useless to a log.
 * - opaque:   "Your 10 AM — the big one. Details in the app."
 *
 * Sensitive calendars are pinned to `opaque` per-calendar regardless of default.
 */
export const RedactionLevel = z.enum(["open", "initials", "opaque"]);
//# sourceMappingURL=redaction.js.map